/**
 * vendorAnzeige — der Anzeigename eines Lieferanten.
 *
 * 🔴 Owner-Entscheid E1 („Anzeige ueberall `metaobject_name`"), umgesetzt in
 * Schritt 3.10 und in der Nachbesserung 1 (2026-10-06, R16 H-4) auf die
 * restlichen Flaechen gezogen.
 *
 * Der Grund: `shp_vendors.vendor_name` traegt bei einem Teil der Lieferanten den
 * SLUG („moins", „pranachai") — er ist die Kennung, nicht die Beschriftung. Der
 * Anzeigename steht in der Spalte `metaobject_name` (Modell: `metafield_name`).
 *
 * Die Regel ist bewusst EINE Zeile und steht an EINER Stelle: `metaobject_name`
 * gewinnt, `vendor_name` ist der Rueckfall (auch der leere Fall ist ein Wert —
 * die Flaechen entscheiden selbst, ob sie `—` zeigen).
 *
 * @useWhen
 *   - Ein Lieferant wird einem Menschen angezeigt (Titel, Tabellenzelle, Option)
 *   - Ein Suchfeld soll das finden, was sichtbar ist
 *
 * @dontUseFor
 *   - Schluessel, Vergleiche und Filter auf die KENNUNG — dafuer `vendor_name`
 *     (bzw. `id`/`vendor_key`). Ein Anzeigename ist nicht stabil und nicht
 *     eindeutig.
 *   - Die RMA-Zuordnung — die laeuft ueber `rma_vendor_configs.vendor_key`.
 *
 * @props
 *   v — { metaobject_name?, vendor_name? } | null | undefined
 */
export const vendorAnzeige = (v) => v?.metaobject_name || v?.vendor_name || '';

export default vendorAnzeige;
